module.exports = __webpack_public_path__ + "static/img/controller_icon.4d136a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/controller_icon.png
// module id = SRhm
// module chunks = 1